/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandFramerMotion = createReactComponent(
  "brand-framer-motion",
  "IconBrandFramerMotion",
  [
    ["path", { d: "M12 12l-8 -8v16l16 -16v16l-4 -4", key: "svg-0" }],
    ["path", { d: "M20 12l-8 8l-4 -4", key: "svg-1" }]
  ]
);

export { IconBrandFramerMotion as default };
//# sourceMappingURL=IconBrandFramerMotion.js.map
